import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { AppConfig } from 'src/app/services/app.config.services';
import { TrsEventsService } from 'src/app/services/trsevents.service';

@Component({
  selector: 'app-gamification',
  templateUrl: './gamification.component.html',
  styleUrls: ['./gamification.component.sass']
})
export class GamificationComponent implements OnInit {
  supervisorLanId: string; //LanID of selected Agent
  srcUrl: any;
  appConfig = AppConfig;

  constructor(private sanitizer: DomSanitizer, private trsService: TrsEventsService) { }

  ngOnInit(): void {
    let supId = this.trsService.supervisorId;
    const url: string = `${this.appConfig.settings.Gamification.Url}${supId}&role=s`;
    this.srcUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}